import { createAction } from "@reduxjs/toolkit";
import * as ACTIONTYPES from "../action-types/catalog";

export const CATEGORYVIEW_TOP_REQUEST_ACTION = createAction<any, string>(
  ACTIONTYPES.CATEGORYVIEW_TOP_REQUEST
);
export const CATEGORYVIEW_TOP_ERROR_ACTION = createAction<unknown, string>(
  ACTIONTYPES.CATEGORYVIEW_TOP_ERROR
);
